import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { PrintServices } from '../../../services/printServices';
import { HttpClient } from '@angular/common/http';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the DishViewLabelPage.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-dish-view-label',
    templateUrl: 'dish-view-label.html',
})
export class DishViewLabelPage {

    dish: any;
    show_price: boolean = false;
    show_logo: boolean = false;
    show_nutrition: boolean = false;
    show_traces: boolean = false;
    elaboration_date: any;
    consumption_date: any;
    lote: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public printServices: PrintServices,
        public http: HttpClient,
        public cp: CurrencyPipe,
        private datePipe: DatePipe,
        public translate: TranslateService) {

        this.dish = this.navParams.get('dish');

    }

    ionViewWillEnter() {
        this.elaboration_date = this.globals.dateTimeNow(); //Get actual date
        this.elaboration_date = this.datePipe.transform(this.elaboration_date, 'yyyy-MM-dd'); //Format date

        this.consumption_date = this.globals.dateTimeNow(); //Get actual date
        this.consumption_date = this.datePipe.transform(this.consumption_date, 'yyyy-MM-dd'); //Format date
    }

    printLabel() {
        if (this.globals.checkLimitsByLicense('dishes', 'print')) {//version pro abierto
            this.globals.GAtrackView('Dish', 'Dish - Label - Print', this.globals.restaurant.email, 'View', 'Print label', 'Dish', this.globals.nameLangSelectDish(this.dish));
            var interval = setInterval(() => {
                this.printServices.printNow('print_label');
                clearInterval(interval);
            }, 1000);
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-view/dish-view-label/dish-view-label.ts